import { render } from "./SuggestionManager.vue?vue&type=template&id=6f20ec63&scoped=true"
import script from "./SuggestionManager.vue?vue&type=script&lang=js"
export * from "./SuggestionManager.vue?vue&type=script&lang=js"

import "./SuggestionManager.vue?vue&type=style&index=0&id=6f20ec63&lang=scss"
import "./SuggestionManager.vue?vue&type=style&index=1&id=6f20ec63&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f20ec63"]])

export default __exports__